// extracted by mini-css-extract-plugin
module.exports = {"alert":"iq","alertIcon":"ir","formContainer":"is","formContainerInner":"it","successIcon":"iu","footer":"iv","footerItem":"iw"};